<template>
    <button
        class="
            relative w-full text-left border border-gray-300 rounded select-none
            transition-colors duration-150
            focus:outline-none
            focus-visible:border-blue-500 focus-visible:ring-1 focus-visible:ring-blue-500
        "
        :class="[
            fontSizeClassName,
            paddingClassName,
            disabled ? 'cursor-not-allowed' : 'cursor-pointer',
            {
                'pr-9': paddingClassName.includes('px-3'),
                'pr-8': paddingClassName.includes('px-2.5'),
                'bg-transparent border-opacity-0': invisible && !opened,
                'bg-gray-200': disabled && !invisible,
                'bg-white': !disabled && !invisible && !highlighted && !boldHighlighted,
                'bg-white hover:border-opacity-100 focus-within:border-opacity-100': !disabled && !highlighted && !boldHighlighted,
                'border-b-blue-500':!disabled && !invisible && highlighted && hasSelectedValue,
                'bg-blue-500 text-white':!disabled && !invisible && boldHighlighted && hasSelectedValue
            }
        ]"
        data-test="select-trigger"
        :disabled="disabled"
        type="button"
    >
        <span class="flex items-center space-x-2">
            <span class="shrink-0 flex">
                <slot name="triggerIcon" />
            </span>
            <template v-if="!isEmpty">
                <span class="-m-0.5 flex grow flex-wrap" v-if="state.isTaggable">
                    <span
                        class="inline-flex items-center m-0.5 rounded bg-blue-500 text-white"
                        :class="$ui.oldFontScale ? 'text-sm' : 'text-xs'"
                        data-test="select-tag"
                        :key="selectedOption.value"
                        v-for="selectedOption in state.selectedOptions"
                    >
                        <span class="px-2 py-0.5" v-text="selectedOption.label" />
                        <button
                            class="
                            shrink-0 inline-flex items-center justify-center rounded-full text-white text-opacity-75 pr-2
                            transition-colors duration-150
                            hover:text-opacity-100
                            focus:outline-none
                        "
                            data-test="select-tag-remove"
                            type="button"
                            @click="events.onDelete(selectedOption.value)"
                        >
                            <Close class="h-2 w-2" />
                        </button>
                    </span>
                </span>
                <span
                    class="block grow truncate"
                    data-test="select-label"
                    v-text="label"
                    v-else
                />
            </template>
            <span
                class="block grow truncate text-gray-400"
                data-test="select-placeholder"
                v-text="state.placeholder"
                v-else
            />
            <span class="absolute inset-y-0 right-0 flex items-center justify-center w-9 pointer-events-none">
                <InterfacePageControllerScrollUpDown class="h-3 w-3 text-gray-400" />
            </span>
        </span>
    </button>
</template>

<script>
    import { t } from '../../locale/index.js';
    import InterfacePageControllerScrollUpDown from '../../assets/svg/line/interface-page-controller-scroll-up-down.svg';
    import Close from '../../assets/svg/bold/close.svg';

    export default {
        inject: ['state', 'events'],

        components: {
            Close,
            InterfacePageControllerScrollUpDown,
        },

        props: {
            disabled: {
                default: false,
                type: Boolean,
            },
            highlighted: {
                default: false,
                type: Boolean,
            },
            boldHighlighted: {
                default: false,
                type: Boolean,
            },
            invisible: {
                default: false,
                type: Boolean,
            },
            opened: {
                default: false,
                type: Boolean,
            },
            paddingClassName: {
                required: true,
                type: null,
            },
        },

        computed: {
            label() {
                const selectedCount = this.state.selectedOptions.length;

                if (selectedCount > 1 && (this.state.withCount && !this.state.isTaggable)) {
                    return `${selectedCount} ${t('select.selected')}`;
                }

                return this.state.selectedOptions.map(selectedOption => {
                    return selectedOption.label;
                }).join(', ');
            },

            isEmpty() {
                return !this.state.selectedOptions.length || this.state.selectedOptions.every(selectedOption => {
                    return !selectedOption.value;
                });
            },

            fontSizeClassName() {
                return this.$ui.oldFontScale ? 'text-base' : 'text-sm';
            },

            hasSelectedValue() {
                return this.state.selectedOptions.length > 0;
            },
        },
    };
</script>
